import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './static/css/global.css';
// 工具函数和全局配置
import './utils/config'
import './utils/util'
import './api/api'

// 路由配置
import Index from './views/index'

ReactDOM.render(
  <React.StrictMode>
      <Index />
  </React.StrictMode>,
  document.getElementById('root')
);
